import { Identity } from "../types";

export const identity: Identity = {
  firstName: "Philippe",
  lastName: "Muller",
  jobTitle: "Software Engineer",
};
